export default "__VITE_ASSET__96b28102__"